import React, { useState } from 'react';
import styles from './SuggestedResponses.module.css';
import { IconButton } from '@mui/material';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';

const SuggestedResponses = ({ responses, onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!responses || responses.length === 0) return null;

  return (
    <div className={styles.container}>
      <IconButton 
        className={styles.toggleButton}
        onClick={() => setIsExpanded(!isExpanded)}
        size="small"
      >
        {isExpanded ? <IoChevronDown size={16} /> : <IoChevronUp size={16} />}
      </IconButton>

      <div className={`${styles.responsesWrapper} ${isExpanded ? styles.expanded : ''}`}>
        {isExpanded && (
          <div className={styles.responses}>
            {responses.map((response, index) => (
              <button
                key={index}
                className={styles.responseButton}
                onClick={() => onSelect(response)}
              >
                {response}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SuggestedResponses;